module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAAXCAYAAAAGAx/kAAAABGdBTUEAALGPC/xhBQAAAAlwSFlzAAALEgAACxIB0t1+/AAAAAd0SU1FB90CGwkLF/BaQSwAAAAZdEVYdENvbW1lbnQAQ3JlYXRlZCB3aXRoIEdJTVBXgQ4XAAAAGHRFWHRTb2Z0d2FyZQBwYWludC5uZXQgNC4wLjOM5pdQAAAAf0lEQVQ4T82OjQqAIAyE7f0fukjSbmvnKSvog4G7n2HhbPs9Kf53KAX+go0kKrFBjOZDuDP9sZvlArUVLxRRQ/2E6RVv+t3D9AoW23tYmOGTQ6ljrxzyR9os48t+n4KVmB6C4agw8joYYkHlmwALKd8EWEj5FRVSfkeFZo6UcgA/jZMBw41q9gAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./assets/icons/agility-icon.png
// module id = 483
// module chunks = 0